import { RiArrowGoBackLine } from 'react-icons/ri';

import { HistoryControllerProps } from './HistoryController.type';
import { ActionButtons } from '../../Form.style';


export const HistoryController = ({
    history,
    setCoordinates,
    setHistory,
    className,
}: HistoryControllerProps) => {
    const handleUndo = () => {
        if (history.length === 0) return;

        const newHistory = [...history];
        const lastState = newHistory.pop();
        if (lastState) {
            setCoordinates(lastState);
            setHistory(newHistory);
        }
    };

    if (history.length === 0) return null;

    return (
        <ActionButtons
            onClick={handleUndo}
            className={className || 'history-undo-button'}
            title="Desfazer última ação"
            type="button"
            aria-label="Desfazer última ação"
        >
            <RiArrowGoBackLine />
        </ActionButtons>
    );
};
